import { Model } from "@vuex-orm/core"
import { notify } from "@/services/notification"
import { getCourseVariants } from "@/utils/helpers"

export default class Course extends Model {
  static get entity() {
    return "courses"
  }

  static fields() {
    return {
      id: this.attr(null),
      start: this.attr(""),
      end: this.attr(""),
      name: this.attr(""),
      room: this.attr(""),
      prof1: this.attr(""),
      prof2: this.attr(""),
      prof3: this.attr(""),
      prof4: this.attr(""),
      drive_link: this.attr(""),
      sunday: this.attr(""),
      saturday: this.attr(""),
      monday: this.attr(""),
      tuesday: this.attr(""),
      wednesday: this.attr(""),
      thursday: this.attr(""),
      friday: this.attr(""),
      start_hours: this.attr("09:00"),
      end_hours: this.attr("17:00"),
      comment: this.attr(""),
      days_total: this.attr(""),
      days_passed: this.attr(""),
      hours_per_day: this.attr(""),
      working_days: this.attr([]),
      levels: this.attr([]),
      status: this.attr([]),
      type: this.attr(""),
      type_full: this.attr(""),
      student_courses: this.attr([]), // sometimes api returns it
      students: this.attr([]), // sometimes api returns it
    }
  }

  get startString() {
    const [day, month, year] = this.start.split("/")
    return `${year}-${month}-${day}`
  }

  get endString() {
    const [day, month, year] = this.end.split("/")
    return `${year}-${month}-${day}`
  }

  get teachers() {
    // if there is prof1 or prof2 or prof3 or prof4 return them as string
    let teachers = []
    if (this.prof1) {
      teachers.push(this.prof1)
    }
    if (this.prof2) {
      teachers.push(this.prof2)
    }
    if (this.prof3) {
      teachers.push(this.prof3)
    }
    if (this.prof4) {
      teachers.push(this.prof4)
    }
    return teachers.join(", ")
  }

  get courseDays() {
    let courseDays = []
    if (this.monday) {
      courseDays.push("Lundi")
    }
    if (this.tuesday) {
      courseDays.push("Mardi")
    }
    if (this.wednesday) {
      courseDays.push("Mercredi")
    }
    if (this.thursday) {
      courseDays.push("Jeudi")
    }
    if (this.friday) {
      courseDays.push("Vendredi")
    }
    if (this.saturday) {
      courseDays.push("Samedi")
    }
    if (this.sunday) {
      courseDays.push("Dimanche")
    }
    return courseDays.join(", ")
  }

  get agenda() {
    return this.start_hours.slice(0, -3) + "-" + this.end_hours.slice(0, -3)
  }

  get levelsString() {
    if (!this.levels || this.levels.length === 0) {
      return "N/A"
    }
    return this.levels.join(", ")
  }

  get levelVariants() {
    return getCourseVariants(this.type)
  }

  countCourseDaysPassed() {
    var endHours = this.end_hours.split(":")

    if (this.working_days?.length) {
      let passed_working_days = []

      this.working_days.forEach((day) => {
        if (new Date(day).setHours(endHours[0], endHours[1], 0, 0) < new Date()) {
          passed_working_days.push(day)
        }
      })
      return passed_working_days.length
    }
    return 0
  }

  countCourseDays() {
    if (this.working_days?.length) {
      return this.working_days.length
    }
    return 0
  }

  static get() {
    return this.api().get("/courses", { dataKey: "data" })
  }

  static async create(course) {
    return await this.api()
      .post(`/courses`, course)
      .catch((error) => {
        notify("error", error.response.data.error)
      })
  }

  static async update(course) {
    return await this.api()
      .put(`/courses/${course.id}`, course)
      .catch((error) => {
        notify("error", error.response.data.error)
      })
  }

  static async deleteOne(id) {
    return await this.api()
      .delete(`/courses/${id}`, {
        delete: id,
      })
      .catch((error) => {
        notify("error", error.response.data.error)
      })
  }

  static async getOneCourseById(id) {
    return await this.api().get(`/courses/${id}`, { dataKey: "data" })
  }

  static async getOneCourseWithStudentsById(id, date) {
    let sendingDate = ""
    if (date) {
      sendingDate = `&date=${date}`
    }
    return await this.api().get(`/courses/with-students?id=${id}${sendingDate}`, {
      dataKey: "data",
    })
  }

  static async getCoursesOverview(onlyActive = true) {
    return await this.api().get(`/courses/overview?onlyActive=${onlyActive}`, {
      dataKey: "data",
    })
  }

  static async getCoursePresenceRates(courseId) {
    const response = await axios.get(`/api/v1/courses/${courseId}/presence-rates`)
    return response.data
  }

  static async registerStudentToCourse(student_id, course_id, level, started_at = null) {
    let url = `/students_course/register?student_id=${student_id}&course_id=${course_id}&level=${level || ""}`
    if (started_at) {
      url += `&started_at=${started_at}`
    }
    return await this.api()
      .post(url, null)
      .then(() => {
        notify("success", "Reussi")
      })
      .catch((error) => {
        notify("error", error.response.data.error)
      })
  }
}
